/**
 * NavLink.js
 * A link inside the navbar
 *
 * @class   NavLink
 * @author  Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';
import LinkMixin from 'mixins/js/LinkMixin'

import Router from 'react-router-component';
const Link = Router.Link;
const RouterMixin = Router.RouterMixin;


export default React.createClass({

	mixins: [ LinkMixin ],

	propTypes: {
		label: React.PropTypes.string,
		onClick: React.PropTypes.func,
		href: React.PropTypes.string,
		target: React.PropTypes.oneOf(['_blank','_self','_parent','_top','framename'])
	},

	getDefaultProps() {
		return {
			href: '',
			target: '_self'
		};
	},

	render() {
		let {
			label,
			className } = this.props;

		let classes = ClassNames('lui-navbar-link', className, {
			'lui-is-active': this.isActive()
		});

		return (
			<li className={classes}>
				<Link {...this.props}>
					{label}
				</Link>
			</li>
		);
	},

});



/** WEBPACK FOOTER **
 ** ./src/components/navbar/NavLink.js
 **/